export function downloadBuffer(buffer: Blob, documentName: string): void {
  const url = window.URL.createObjectURL(buffer);
  const a = document.createElement('a');
  document.body.append(a);
  a.href = url;
  a.download = documentName;
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
}
